import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Switch from 'react-switch';
import { FlexBetween } from '../../styles/stylesStyled';
import { Box, NotificationSubtitle, NotificationTitle } from './SettingsStyled';

import { PageTitle } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { setNotification } from './Settings.actions';
import { useAppSelector } from '../../app/hooks';
import { CaptionText, P1, P2 } from '../../styles/FontStyles';

export const NotificationsSettings = () => {
  const dispatch = useDispatch();
  const { notifications } = useAppSelector((state) => state.settings);

  const { t } = useTranslation('settings');

  const newNotifications = [
    {
      id: 1,
      title: t('notifications.earnings.title'),
      subtitle: t('notifications.earnings.subtitle')
    },
    // {
    //   id: 2,
    //   title: t('notifications.news.title'),
    //   subtitle: t('notifications.news.subtitle')
    // },
    // {
    //   id: 3,
    //   title: t('notifications.promotions.title'),
    //   subtitle: t('notifications.promotions.subtitle')
    // },
    {
      id: 4,
      title: t('notifications.referral.title'),
      subtitle: t('notifications.referral.subtitle')
    }
  ];

  return (
    <>
      <PageTitle>{t('account.notifications')}</PageTitle>

      <Box>
        {notifications?.map((item: any, index: number) => {
          return (
            <FlexBetween
              style={{
                marginBottom: index + 1 === notifications.length ? 0 : 16
              }}
              key={index}>
              <div>
                <P2 bold mb='4'>
                  {item.id === newNotifications[index].id &&
                    newNotifications[index].title}
                </P2>
                <CaptionText color={color.colors.neutral500}>
                  {item.id === newNotifications[index].id &&
                    newNotifications[index].subtitle}
                </CaptionText>
              </div>
              <Switch
                onChange={() => dispatch(setNotification(item))}
                checked={item.checked}
                checkedIcon={false}
                uncheckedIcon={false}
                onColor={color.colors.secondary100}
              />
            </FlexBetween>
          );
        })}
      </Box>
    </>
  );
};
